import React from "react";
import { useThemeProvider } from "../../providers/ThemeProvider";

export const CafeBazzarIconShapeComponent = ({ position = "left" }) => {
  const theme = useThemeProvider();
  return (
    <div className={theme.styles.classes.componentsShapeStoreIcon}>
      <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 44 44">
        <path
          d="M43.7,14.4c-0.7-0.5-2-1.1-4.5-1.7c-0.8-0.2-1.6-0.3-2.6-0.5c-1.2-0.2-2.7-0.4-4.3-0.5l-0.2,0c-0.3-0.8-0.7-1.5-1.1-2.4
	c-0.2-0.4-0.4-0.9-0.6-1.4c0-0.1,0-0.1-0.1-0.2c-0.7-1.7-1.5-3.5-2.8-5.1C26,1,24,0,22,0c-2,0-4,1-5.4,2.7c-1.3,1.6-2.1,3.4-2.8,5.1
	L13.7,8c-0.2,0.5-0.4,0.9-0.6,1.4c-0.4,0.8-0.7,1.6-1.1,2.4l-0.2,0c-1.7,0.1-3.1,0.3-4.4,0.5c-1,0.1-1.8,0.3-2.6,0.5
	c-2.5,0.6-3.8,1.2-4.5,1.7c-0.1,0.1-0.2,0.2-0.3,0.3C0,14.9,0,15,0,15.1l0.2,1.6c0.3,2.3,0.7,5.1,1.3,7.9c0.4,2.2,1,4.3,1.8,6.4
	c0.3,0.8,0.7,1.6,1,2.4c1.6,3.2,4.2,5.9,7.3,7.7c3.2,1.9,6.8,2.8,10.5,2.8c3.7,0,7.3-1.1,10.4-3c3.1-1.9,5.6-4.6,7.2-7.8
	c0.3-0.6,0.6-1.3,0.8-1.9c1.8-4.6,2.5-9.8,3.1-13.8l0.3-2.3c0-0.1,0-0.3-0.1-0.4C43.9,14.6,43.8,14.5,43.7,14.4z M22,11.3
	c-2,0-3.9,0-5.6,0.1c0.1-0.2,0.2-0.4,0.3-0.6c0.2-0.5,0.4-1,0.6-1.4c0.4-1.1,0.9-2.1,1.4-3.1c0.3-0.4,0.5-0.8,0.9-1.2
	C20,4.6,20.9,3.8,22,3.8c1.1,0,2,0.8,2.4,1.3c0.3,0.4,0.6,0.8,0.9,1.2c0.6,1,1,2,1.4,3.1c0.2,0.5,0.4,1,0.6,1.4
	c0.1,0.2,0.2,0.4,0.3,0.6C25.9,11.4,24,11.3,22,11.3z"
        />
      </svg>
    </div>
  );
};

export const MyketIconShapeComponent = ({ position = "left" }) => {
  const theme = useThemeProvider();
  return (
    <div className={theme.styles.classes.componentsShapeStoreIcon}>
      <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 700 700">
        <path
          d="M350.9,15.3C166.1,15.3,16.2,165.2,16.2,350s149.8,334.7,334.7,334.7S685.6,534.8,685.6,350S535.8,15.3,350.9,15.3z
         M441.9,494c-21.1,30.5-53.3,44.2-91,44.2c-37.7,0-69.9-13.7-91-44.2c0,0-2.6-4.2-0.9-6.8c1.3-2.4,5.7,2.2,5.7,2.2
        c16.7,17.9,50.7,29.4,86.2,29.4s69.7-11.5,86.2-29.4c0,0,4.4-4.4,5.7-2.2C444.5,489.8,442.1,493.9,441.9,494z M556.7,446.2
        c0,16.1-13.1,29.4-29.4,29.4h-0.7c-16.1,0-29.4-13.1-29.4-29.4V316H497c0-32.6-26.9-59.3-59.5-59.3s-59,26.1-59.2,58.8v110
        c0,16.5-13.3,29.8-29.8,29.8h-0.7c-16.5,0-29.8-13.3-29.8-29.8V315.8h-0.2c0-32.6-26.5-59.2-59.2-59.2c-32.6,0-59.2,26.5-59.2,59.2
        h-0.2v130c0,16.5-13.3,29.8-29.8,29.8h-0.7c-16.5,0-29.8-13.3-29.8-29.8V311.5c0-1.6,0-3.3,0.2-4.6c4.6-61.9,56-110.2,118.7-110.2
        c35.5,0,67.5,15.7,89.3,40.3c21.8-24.6,53.8-40.3,89.3-40.3c64,0,116.1,50.3,118.9,113.7c0,0.8,0,1.5,1.4,3V446.2z"
        />
      </svg>
    </div>
  );
};
